export const handleUrlDownload = (url: string, filename: string) => {
	const anchor = document.createElement("a");
	anchor.href = url;
	anchor.setAttribute("download", filename);
	document.body.appendChild(anchor);
	anchor.click();
	document.body.removeChild(anchor);
};
